import * as _ from 'lodash'
import axios from 'axios'


class DocumentsEnum {

  getDocumentsByInterface(interfaces) {
    return axios.post(`/v2/documentos/listaDocs`, { interfaces }).then((res) => {
      return res.data;
    });
  }


}

const instance = new DocumentsEnum();
export default instance;



// WEBPACK FOOTER //
// ./src/services/documents.js